import React from 'react';

function Community() {
  return (

<div className="container mx-auto p-8">
      <div className="bg-white rounded-lg mt-8 shadow-lg p-6 border border-gray-400">
        <h1 className="text-3xl font-bold  mb-6">Atlanta Tech Community</h1>
        
        <div className="space-y-4 text-left">
         
        <div className="prose max-w-none">
        <p className="mb-4">
          Atlanta's tech community is one of the strongest you'll find. From collaboration, incubators, investors, and the support community, there's nothing you can't find in Atlanta.
        </p>
        <p>
          We appreciate the support of our community sponsors in making ATL Tech Events possible. Want to be a community sponsor? Contact us on <a href="https://www.linkedin.com/company/atl-tech-events" className="text-blue-500 underline" target="_blank" rel="noopener noreferrer">LinkedIn</a> to discuss.</p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">Community Partners</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex items-center gap-4">
                <div><a href="https://engage.isaca.org/atlantachapter/home" target="_blank" rel="noopener noreferrer"><img src="/logos/ISACA_logo_Atlanta_RGB.png" className="w-48" alt="ISACA Atlanta" /></a></div>
            </div>
        </div>

        <h2 className="text-2xl font-semibold mt-8 mb-4">In-Kind Partners</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex items-center gap-4">
                <div><a href="https://www.atl.tech/" target="_blank" rel="noopener noreferrer"><img src="/logos/ATW_full_black.png" className="w-48" alt="Atlanta Tech Week" /></a></div>
            </div>
        </div>

        <h2 className="text-2xl font-semibold mt-8 mb-4">Additional Technology Organizations</h2>
        <p>(In alphabetical order)</p>
        <ul>
            <li><a href="https://angelatlanta.com/" target="_blank" className="text-blue-500 underline" rel="noopener noreferrer">Atlanta Technology Angels</a></li>
            <li><a href="https://www.atdc.org/" target="_blank" className="text-blue-500 underline" rel="noopener noreferrer">ATDC</a></li>
            <li><a href="https://www.atlantatechpark.com/" target="_blank" className="text-blue-500 underline"  rel="noopener noreferrer">Atlanta Tech Park</a></li>
            <li><a href="https://atpconnect.org/" target="_blank" className="text-blue-500 underline" rel="noopener noreferrer">Atlanta Technology Professionals</a></li>
            <li><a href="https://www.hdiatlanta.org/cpages/home" target="_blank" className="text-blue-500 underline" rel="noopener noreferrer">HDI Atlanta</a></li>
            <li><a href="https://www.hypepotamus.com/" target="_blank" className="text-blue-500 underline" rel="noopener noreferrer">Hypepotamus</a></li>
            <li><a href="https://www.issaatl.org/" target="_blank" className="text-blue-500 underline" rel="noopener noreferrer">ISSA Metro Atlanta Chapter</a></li>
            <li><a href="https://www.russellcenter.org/" target="_blank" className="text-blue-500 underline" rel="noopener noreferrer">Russell Center</a></li>
            <li><a href="https://chapter.simnet.org/atlanta/home" target="_blank" className="text-blue-500 underline" rel="noopener noreferrer">SIM Atlanta</a></li>
            <li><a href="https://startupatlanta.com/" target="_blank" className="text-blue-500 underline" rel="noopener noreferrer">Startup Atlanta</a></li>
            <li><a href="https://techalpharetta.com/" target="_blank" className="text-blue-500 underline" rel="noopener noreferrer">Tech Alpharetta</a></li>
            <li><a href="https://www.tagonline.org/" target="_blank" className="text-blue-500 underline" rel="noopener noreferrer">Technology Association of Georgia (TAG)</a></li>
            <li><a href="https://techsmartseniors.org/" target="_blank" className="text-blue-500 underline" rel="noopener noreferrer">TechSmart for Seniors</a></li>
            <li><a href="https://www.techstars.com/" target="_blank" className="text-blue-500 underline" rel="noopener noreferrer">Techstars</a></li>
            <li><a href="https://tieatlanta.org/" target="_blank" className="text-blue-500 underline" rel="noopener noreferrer">TiE Atlanta</a></li>
            <li><a href="https://mywit.org/" target="_blank" className="text-blue-500 underline" rel="noopener noreferrer">Women in Technology</a></li>
        </ul> 

        <p className="mt-8">Who are we missing? Let us know on <a href="https://www.linkedin.com/company/atl-tech-events" target="_blank" className="text-blue-500 underline" rel="noopener noreferrer">LinkedIn</a>!</p>

      </div>

        </div>
      </div>
    </div>

  );
}

export default Community; 